// extracted by mini-css-extract-plugin
export default {"screensDisplayHeightForPanel":"dOuHXczf63dJqb7ErKx3","screensDisplayHeightForDropDown":"QBan9H8MPNpR0mTsDJsQ"};